<ng-template #bookingPaymentModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ "heading-title.select-payment-method" | translate }}</h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        id="close-support-ticket-close-confirmation-modal"
        (click)="closeBookingPaymentModal()"
      ></button>
    </div>
    <div class="modal-body">
      <div class="d-flex mb-3">
        @for(payment of paymentGateways; track $index){
        <div class="form-check form-radio-secondary me-2">
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault{{ $index }}"
            (change)="onRadioChange(payment)"
            [checked]="selectedGatewayType === payment.key"
            [disabled]="
              (payment.key === helper.PaymentMode.Wallet && helper.dispatcherDetails.entity.credit < amount) ||
              (isLaterStripePaymentThenHideOtherMethod && payment.key !== helper.PaymentGatewayEnum.Stripe)
            "
          />
          <label class="form-check-label" for="flexRadioDefault{{ $index }}">
            {{ payment.string | translate | titlecase }}
          </label>
        </div>
        }
      </div>
      <form class="needs-validation" method="post">
        <div style="max-height: 250px; overflow-y: auto">
          <div class="vstack gap-2">
            @for (card of cards; track $index) {
            <div class="form-check card-radio position-relative">
              <input [checked]="card.isDefault" id="listGroupRadioGrid{{ $index }}" (change)="onSelectCard(card)" type="radio" class="form-check-input" />
              <label class="form-check-label" for="listGroupRadioGrid{{ $index }}">
                <div class="d-flex justify-content-between">
                  <div class="flex-shrink-0">
                    <div class="avatar-xs">
                      <div class="avatar-title bg-success-subtle text-success fs-20 rounded">
                        <i class="ri-bank-card-2-line"></i>
                      </div>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <div>
                      <div class="credit-card_number">XXXX XXXX XXXX {{ card.lastFour }}</div>
                    </div>
                    <div class="credit-card_expiration">{{ "label-title.valid-thru" | translate | titlecase }}: {{ card.expM }}/{{ card.expY }}</div>
                  </div>
                </div>
              </label>
            </div>
            } @empty{ @if(selectedGatewayType && helper.PaymentGatewayCardEnumArray.includes(selectedGatewayType)) {
            <h6 class="mb-0 py-4 text-center">
              {{ "label-title.no-card-found" | translate }}
            </h6>
            } }
          </div>
        </div>
        @if(helper.PaymentGatewayCardEnumArray.includes(selectedGatewayType)) { @if (isPaymentOptionError) {
        <div class="invalid-message">
          {{ "label-title.please-add-card" | translate }}
        </div>
        } } @if(selectedGatewayType && helper.PaymentGatewayCardEnumArray.includes(selectedGatewayType)){
        <button class="btn btn-sm btn-secondary mt-3 float-start" (click)="addCard()"><i class="ri-add-circle-fill"></i> {{ "label-title.add-card" | translate }}</button>
        }
        <button
          class="btn btn-sm btn-secondary mt-3 float-end"
          (click)="applyPaymentMethod()"
          [disabled]="isPaymentOptionError && helper.PaymentGatewayCardEnumArray.includes(selectedGatewayType)"
        >
          {{ "button-title.apply" | translate }}
        </button>
      </form>
    </div>
  </div>
</ng-template>

<app-add-new-card #addNewCard (cardUpdated)="selectGateway()"></app-add-new-card>
